import React from "react";
import { Outlet } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { LogOut } from "lucide-react";

export default function OnboardingLayout() {
  const handleSignOut = async () => {
    await supabase.auth.signOut();
    window.location.href = "/login";
  };

  return (
    <>
      <button
        onClick={handleSignOut}
        className="fixed top-4 right-4 z-20 flex items-center gap-1.5 text-[12px]
                   text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300
                   transition-colors duration-200 h-9 px-3 rounded-full
                   hover:bg-white/70 dark:hover:bg-slate-800/70 backdrop-blur-sm
                   active:scale-[0.97] shadow-sm"
        aria-label="Cerrar sesión"
      >
        <LogOut size={13} />
        <span>Salir</span>
      </button>
      <Outlet />
    </>
  );
}
